export default class Form {
    constructor(responseRenderer, cookieManager) {
        this.renderer = responseRenderer;
        this.cookieManager = cookieManager;
    }

    callback(callback) {
        this.callback = callback;
    }

    callbackError(callbackError) {
        this.callbackError = callbackError;
    }

    runCallback(callback, form, json) {
        if (typeof callback !== 'undefined') {
            if (typeof callback == 'string') {
                callback = window[callback];
            }

            callback(form, json);
        }
    }

    submit(form) {
        // any messages should be hidden then reloaded in
        // in order to indicate if the form submitted, even
        // if it results in the same message
        $('.alert').hide();

        // set any buttons in the form to show loading and disable
        // to prevent multiple clicks
        var btns = $(form).find('.btn');
        btns.button('loading');

        var $this = this;
        $.post($(form).attr('action'), $(form).serialize())
            .done(function (data) {
                // re-enable form buttons
                btns.button('reset');

                try {
                    var json = $.parseJSON(data);
                }
                catch(err) {
                    // invalid JSON means some server-side error
                    // we'd still like to be able to handle that
                    $this.renderer.fail(data);
                    return;
                }

                if (
                    typeof json['redirect'] !== "undefined"
                    && json['redirect'].length > 0
                ) {
                    // handle redirect
                    // save messages to display on redirect landing
                    $this.cookieManager.createCookie('redirectMessages', data, 1);
                    window.location = json['redirect'];
                    return;
                }

                $this.renderer.done(json);

                if (typeof json['errors'] !== "undefined") {
                    $this.runCallback($this.callbackError, form, json);
                    return false;
                }

                $this.runCallback($this.callback, form, json);
            }).fail(function (data) {
                // server error
                // try to display what information we do get
                btns.button('reset');
                $this.renderer.fail(data);
            });

        return false;
    }
}



// WEBPACK FOOTER //
// ./app/Form.js